import { render, staticRenderFns } from "./CtaFixedMenu.vue?vue&type=template&id=5e37959a&scoped=true"
import script from "./CtaFixedMenu.vue?vue&type=script&lang=js"
export * from "./CtaFixedMenu.vue?vue&type=script&lang=js"
import style0 from "./CtaFixedMenu.vue?vue&type=style&index=0&id=5e37959a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37959a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/elements/Button.vue').default})
